// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1SUlI","modalForm":"UpgradeEpcsModal_modalForm__6KVHU","modalFooter":"UpgradeEpcsModal_modalFooter__3hXia"};